import React from "react";
import { Phone, MapPin, MessageSquare } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, NAV_LINKS, scrollToId } from "../../lib/site";

export const Footer = () => {
  const go = (href) => scrollToId(href);
  return (
    <footer data-testid="site-footer" className="relative bg-[#0a0a0a] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/kat-logo.png" alt="KAT Transportation Services" className="h-14 w-14 object-contain" />
              <div>
                <div className="font-serif-display text-2xl text-gold-gradient leading-none">KAT</div>
                <div className="text-[10px] tracking-[0.28em] text-neutral-400 uppercase mt-1">Transportation Services</div>
              </div>
            </div>
            <p className="text-neutral-500 mt-5 leading-relaxed max-w-sm text-sm">
              Family-operated transportation you can count on. Serving Haymarket, VA and surrounding neighborhoods with reliable, personal rides.
            </p>
            <p className="text-neutral-400 mt-4 leading-relaxed max-w-md text-[13px]">
              KAT Transportation Services provides airport transportation to Dulles (IAD), Reagan National (DCA) and BWI,
              medical and doctor appointment rides, senior transportation, and personal local trips throughout Haymarket,
              Gainesville, Bristow, Warrenton and the greater Prince William County area of Northern Virginia. Owned and
              operated by Rui Godoy. Call or text 703-296-8036 to book your ride.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.24em] uppercase text-[#D4AF37] font-semibold mb-5">Explore</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => go(l.href)}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-neutral-400 hover:text-[#D4AF37] transition-colors text-sm"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.24em] uppercase text-[#D4AF37] font-semibold mb-5">Get in Touch</div>
            <a href={`tel:${PHONE_TEL}`} data-testid="footer-call" className="flex items-center gap-3 text-white hover:text-[#D4AF37] transition-colors">
              <Phone size={16} className="text-[#D4AF37]" /> <span className="font-serif-display text-xl">{PHONE_DISPLAY}</span>
            </a>
            <a href={`sms:${PHONE_TEL}`} className="flex items-center gap-3 text-neutral-400 hover:text-[#D4AF37] transition-colors mt-3 text-sm">
              <MessageSquare size={16} className="text-[#D4AF37]" /> Call or text anytime
            </a>
            <div className="flex items-center gap-3 text-neutral-400 mt-3 text-sm">
              <MapPin size={16} className="text-[#D4AF37]" /> Haymarket, VA &amp; surrounding areas
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-neutral-600 text-xs">© {new Date().getFullYear()} KAT Transportation Services. All rights reserved.</p>
          <p className="text-neutral-600 text-xs">Owner &amp; Operator: Rui Godoy</p>
        </div>

        <div className="mt-4 text-center">
          <p className="text-neutral-700 text-[11px]">
            Made by{" "}
            <a
              href="https://infinitysolutionshub.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-credit-link"
              className="text-neutral-500 hover:text-[#D4AF37] transition-colors underline underline-offset-2"
            >
              Infinity Solutions Hub
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
